export const Loader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 16"
      aria-hidden="true"
      width={75}
    >
      <style>
        {`
          @keyframes fade {
            0% { opacity: 0; }
            12%,76% { opacity: 1; }
            32% { stroke-dashoffset: 0; }
            56% { stroke-dashoffset: -28; }
            88% { opacity: 0; stroke-dashoffset: -28; }
            100% { opacity: 0; stroke-dashoffset: 0; }
          }
          .o {
            stroke: #dee2e6;
            stroke-width: 2;
            stroke-dasharray: 14,14;
            stroke-dashoffset: 0;
            stroke-linecap: round;
          }
          .i1 { animation: fade 2.4s ease-in-out infinite; }
          .i2 { animation: fade 2.4s ease-in-out .1s infinite; }
          .i3 { animation: fade 2.4s ease-in-out .2s infinite; }
          .i4 { animation: fade 2.4s ease-in-out .3s infinite; }
        `}
      </style>
      <g className="o">
        <path className="i1" d="M1 1v14" />
        <path className="i2" d="M7 1v14" />
        <path className="i3" d="M13 1v14" />
        <path className="i4" d="M19 1v14" />
      </g>
    </svg>
  );
};
